import { render, staticRenderFns } from "./NewSettings.vue?vue&type=template&id=7fad4c1e&scoped=true&"
import script from "./NewSettings.vue?vue&type=script&lang=js&"
export * from "./NewSettings.vue?vue&type=script&lang=js&"
import style0 from "./NewSettings.vue?vue&type=style&index=0&id=7fad4c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fad4c1e",
  null
  
)

export default component.exports